import React from "react";
import emailAlertsFiltersStore from './EmailAlertsFiltersStore';
import { throttle } from 'lodash';

const propTypes = {};

const defaultProps = {};



export default function EmailAlertsStringFilter() {

  const setSubjectQuery = throttle(string => {
    emailAlertsFiltersStore.setState({
      subjectQuery: string
    });
  }, 500);

  return (
    <div className="input-group">
      <input
        type="text"
        className="form-control"
        placeholder="Search"
        charSet="utf-8"
        onChange={val => {
          setSubjectQuery(val.target.value)
        }}
      />
      <div className="input-group-append">
        <span className="input-group-text">
          <i className="far fa-search"></i>
        </span>
      </div>
    </div>
  );
}

EmailAlertsStringFilter.propTypes = propTypes;
EmailAlertsStringFilter.defaultProps = defaultProps;
